module.exports = "<button class=\"focusable\"\n        ng-class=\"{'has-badge': vm.badge}\"\n        ng-click=\"vm.onSelect()\"\n        ng-keydown=\"vm.keyDown($event)\"\n        ng-keyup=\"vm.keyUp($event)\"\n        tabindex=\"0\">\n  <div>\n    <div ng-transclude></div>\n    <div ng-if=\"vm.badge\" class=\"badge\">{{vm.badge}}</div>\n  </div>\n</button>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/news12Button/news12Button.html
 ** module id = 111
 ** module chunks = 0
 **/